module.exports = __webpack_public_path__ + "static/media/image1.55f1e809.png";